import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pause-meeting-container detail-popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Reschedule Meeting", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "This meeting will be cancelled, and the recipient will recieve a message to reschedule.", -1 /* HOISTED */)
const _hoisted_5 = { class: "notes" }
const _hoisted_6 = { class: "button-container horizontal" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createBlock($setup["Loader"], {
          key: 0,
          class: "loader",
          "full-screen": true
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CloseButton"], { onClick: $setup.deepClosePopup }),
    _createVNode($setup["DetailsHeader"], {
      meetingMoment: $setup.meetingMoment,
      name: $setup.name
    }, null, 8 /* PROPS */, ["meetingMoment", "name"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["TextField"], {
          class: "note what-happned-note",
          label: "Details",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.message) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "borderless back",
        onClick: $setup.closePopup
      }, "Back"),
      _createElementVNode("button", {
        class: "primary submit",
        disabled: !$setup.message,
        onClick: $setup.pauseMeeting
      }, "Ask to Reschedule", 8 /* PROPS */, _hoisted_7)
    ])
  ]))
}